// De app is verhuisd (oprichter 28 sep 2026: amumin.app). Caddy stuurt elke pagina op het oude
// adres (f.amumin.com) met 308 door, maar een tabblad dat al openstond, praat nog met de API op
// het oude adres. Die antwoordt 401 `moved` met het nieuwe adres (apps/api/src/plugins/
// legacyHosts.ts). Dan gaan we er rustig heen, met dezelfde pagina; inloggen gebeurt daar.
// Alleen naar een kale https-origin (of http in dev) en nooit naar het adres waar we al zijn.

interface Here {
  origin: string;
  pathname: string;
  search: string;
}

/** Het nieuwe adres voor een 401 `moved`, of null. */
export function movedTarget(status: number, body: unknown, here: Here): string | null {
  if (status !== 401 || !body || typeof body !== 'object') return null;
  const err = (body as { error?: { code?: unknown; details?: { location?: unknown } } }).error;
  if (!err || err.code !== 'moved' || !err.details) return null;
  const loc = err.details.location;
  if (typeof loc !== 'string') return null;
  const m = /^(https?:\/\/[a-z0-9.-]+(?::\d+)?)\/?$/i.exec(loc);
  if (!m?.[1]) return null;
  const origin = m[1].toLowerCase();
  if (origin === here.origin.toLowerCase()) return null;
  if (here.origin.startsWith('https:') && !origin.startsWith('https:')) return null;
  return `${origin}${here.pathname}${here.search}`;
}

/** fetch voor de API-client: bij 401 `moved` naar het nieuwe adres. */
export function movedAwareFetch(base: typeof fetch = fetch): typeof fetch {
  return async (input, init) => {
    const res = await base(input, init);
    if (res.status !== 401 || typeof window === 'undefined') return res;
    try {
      const body: unknown = await res.clone().json();
      const target = movedTarget(res.status, body, window.location);
      if (target) window.location.replace(target);
    } catch {
      // Geen JSON: een gewone 401.
    }
    return res;
  };
}
